import { dailySessionNotes } from '../../actions/constant';

const {
  SUCCESS_GET_NOTE_TEMPLATE,
  FAILURE_GET_NOTE_TEMPLATE,
  LOADING_GET_NOTE_TEMPLATE,
  RESET_GET_NOTE_TEMPLATE,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  loading: false,
  isGetTemplate: false,
};

export const getNoteTemplateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_NOTE_TEMPLATE: {
      return {
        ...state,
        isGetTemplate: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_NOTE_TEMPLATE:
      return {
        ...state,
        isGetTemplate: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_GET_NOTE_TEMPLATE:
      return {
        ...state,
        loading: true,
      };

    case RESET_GET_NOTE_TEMPLATE:
      return intitialstate;

    default:
      return state;
  }
};
